import { render, staticRenderFns } from "./newYear.vue?vue&type=template&id=7c6af9a1&"
import script from "./newYear.vue?vue&type=script&lang=js&"
export * from "./newYear.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports